<template>
    <boton-accion 
        ref="boton"
        v-for="accion in acciones" 
        :accion="accion"        
        :key="accion" 
        :datos="datos"
        :nombredos="nombredos">
    </boton-accion>
</template>
<script>
import BotonAccion from './BotonAccion.vue'
export default {
    props: [ 'acciones', 'datos','nombredos' ],
    components: {
        'boton-accion': BotonAccion
    },
    methods:{
        cambio(){
            for(let boton of this.$refs.boton){
                boton.comprobarLog();
            }
        }
    }
}
</script>